export const BX_CATEGORY_HASH ={
    1:'市内交通、快递费、办公软件相关、办公用品',
    2:'团建费用（餐饮、交通）',
    3:'外部购买图书和课程',
    4:'内部购买课程、周边',
    5:'跨组约咖啡',
    6:'组内约咖啡',
    7:'出差学习（住宿、交通、餐饮等）',
    8:'出差工作（住宿、交通、餐饮等）',
    9:'开会物料、餐饮、零食等',
    10:'用户运营红包、礼物',
    11:'加班餐、工作餐',
    12:'产品研发（如购买教具等）',
    13:'其他'
}